// extracted by mini-css-extract-plugin
export default {"icon":"Copy_icon__3aTu5"};